"use client"; // Note: This directive is Next.js-specific and might not be needed in plain React, depending on your setup

import React, { useState, useEffect } from "react";

import { ArrowLeft, Copy } from "lucide-react";
import { Button } from "../../components/ui/button";
import { toast } from "../../hooks/use-toast";
import inviteImage from "../../assets/images/settings/invite_to_88_page.svg";
import Header from "../../layouts/Header";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Toaster from "../../components/ui/toaster";

const InviteTo80eight = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const [referralCode, setReferralCode] = useState("");

  const copyToClipboard = () => {
    navigator.clipboard.writeText(userProfile.ref_info.user_code);
    toast({
      description: "Your referral code has been copied.",
      variant: "eighty",
    });
  };

  return (
    <>
      <Header />
      <Toaster />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20"
            onClick={() => {
              navigate("/settings/index");
            }}
          />
          <p className="text-sm font-medium underline mr-2">Settings</p>
          <p className="text-sm font-medium"> / Invite to 80eight</p>
        </div>

        {/* Main Content */}
        <div className="flex justify-center mt-16 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full bg-white rounded-2xl px-10 py-20 flex flex-col items-center">
            {/* Icon */}
            <img
              src={inviteImage}
              alt="Invite to 80eight"
              width={200}
              height={200}
              className="mb-6"
            />

            {/* Title and Description */}
            <h2 className="font-semibold text-[20px] text-brand-primary mb-2">
              Invite people to 80eight
            </h2>
            <p className="text-sm text-gray-600 text-center mb-12">
              Refer 5 friends using your referral code
            </p>
            {/* <p className="text-sm text-gray-600 text-center mb-8">
            earn <span className="font-bold">R1,500</span> in crypto.
          </p> */}

            {/* Referral Code */}
            <div className="flex items-center justify-between bg-bg-light-gray  rounded-md px-4 py-2 w-80 max-w-md">
              <span className="text-lg font-semibold text-rose-500">
                {userProfile.ref_info.user_code}
              </span>
              <Button
                variant="ghost"
                className="p-[10px] text-gray-600 hover:text-gray-800 rounded-full border-[1px] border-bg-neutral"
                onClick={copyToClipboard}
              >
                <Copy className="w-5 h-5 text-text-secondary" strokeWidth="1" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InviteTo80eight;
